export default __webpack_public_path__ + "static/media/audio.804e35ec.png";